import React, { Component } from 'react';
import Style from './licenseManagement.module.css';
import { connect } from 'react-redux';
import { setCurrentCustomer } from '../store/entities/customers'; 
import LoaderWrapper from './common/LoaderWrapper/LoaderWrapper';
import { isGlobalView } from '../utilities/config';
import LicenseManagementTab from './LicenseManagement/LicenseManagementTab';
import DevicesTab from './LicenseManagement/DevicesTab';
import UsersTab from './LicenseManagement/UsersTab';


class LicenseManagement extends Component {

  state = {
    selectedTab: 'License Management',
  }

  populateCustomerData = () => {    
    if(this.props.selectedCustomer) {
      // const selectedId = this.props.match.params.id;
      // const defaultCustomerId = this.props.selectedCustomer?.defaultCustomerId;
      // const globalView = isGlobalView(this.props.selectedCustomer?.organizationName);
    }
  }

  componentDidMount = () => {
    // Restore tab from navigation state (e.g. returning from detail page)
    if (this.props.location && this.props.location.state && this.props.location.state.tab) {
      this.setState({ selectedTab: this.props.location.state.tab });
    }

    if (this.props.selectedCustomer && this.props.selectedCustomer.id === this.props.match.params.id) {
      this.populateCustomerData();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let arrSelectedCustomer = this.props.orgList.filter((ele) => ele.id === this.props.match.params.id);

    if (this.props.selectedCustomer !== prevProps.selectedCustomer && this.props.selectedCustomer.id === arrSelectedCustomer[0].id ) {
      this.props.setCurrentCustomer(arrSelectedCustomer[0]);
      this.populateCustomerData();
      this.setState({ selectedTab:'License Management' })
    } else if(this.props.selectedCustomer && arrSelectedCustomer[0] && this.props.selectedCustomer.id !== arrSelectedCustomer[0].id) {
      this.props.setCurrentCustomer(arrSelectedCustomer[0]);
      this.setState({ selectedTab:'License Management' })
    }
  }

  handleTabClick = (tab) => {
    this.setState({ selectedTab: tab })
  }

  render() {
    return (
      <>
      <div className={`${Style.navbar} pl-4 d-flex`}>
        <div onClick={() => this.handleTabClick('License Management')} className={`${this.state.selectedTab === 'License Management' ? Style.navbarSelectedItemStyle : Style.navbarFontStyle} d-flex align-items-center`} style={{ marginLeft: '53px' }} > License Management </div>
        {this.props.userRole == 'PixmAdmin' && <div onClick={() => this.handleTabClick('Device Info')} className={`${this.state.selectedTab === 'Device Info' ? Style.navbarSelectedItemStyle : Style.navbarFontStyle} d-flex align-items-center px-3 mx-2`} > Device Info </div>}
        {this.props.userRole == 'PixmAdmin' && <div onClick={() => this.handleTabClick('User Info')} className={`${this.state.selectedTab === 'User Info' ? Style.navbarSelectedItemStyle : Style.navbarFontStyle} d-flex align-items-center px-3 mx-2`} > User Info </div>}
      </div>
      { this.props.customerLoading ? <LoaderWrapper loading={this.props.customerLoading} waitForData={false} isFlex={true} styles={{top: '100px'}}></LoaderWrapper> : 
      <span>
      {this.state.selectedTab === 'License Management' && (
        <LicenseManagementTab history={this.props.history} matchParams={this.props.match.params} />
      )}
      {this.state.selectedTab === 'Device Info' && (
        <DevicesTab history={this.props.history} matchParams={this.props.match.params} />
      )}
      {this.state.selectedTab === 'User Info' && (
        <UsersTab history={this.props.history} matchParams={this.props.match.params} />
      )}
      </span>
  }
      </>
    )
  }
}
const mapStateToProps = (state) => ({
  selectedCustomer: state.entities.customers.selected,
  orgList: state.entities.customers.list,
  customerLoading: state.entities.customers.loading,
  userRole: state.entities.user.roles,
})

const mapDispatchToProps = (dispatch) => ({
  setCurrentCustomer: (customerId) => dispatch(setCurrentCustomer(customerId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LicenseManagement)
